module.exports = __webpack_public_path__ + "static/media/WBTC.28db4fc6.svg";